import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { requestSimilarOffers, TModelType } from '../../store/similar';
import { ISimilarOffersProps, SimilarOffers } from './SimilarOffers';
import { getUserEBC } from '../../utils/tracking/get_user_ebc';
import { getPageEBC } from '../../utils/tracking/get_page_ebc';

const SIMILAR_OFFERS_MAX_COUNT = 5;

type TStoreProps = Pick<
  ISimilarOffersProps,
  'agent' | 'offer' | 'similarOffers' | 'withoutCompetitors' | 'modelVersion' | 'title' | 'user' | 'page' | 'modelType'
>;
type TDispatchProps = Pick<ISimilarOffersProps, 'requestSimilarOffers'>;
export interface IOwnProps {
  modelType: TModelType;
}

export function getTitle(modelType: TModelType, withoutCompetitors: boolean): string {
  if (withoutCompetitors) {
    return 'Другие предложения этого продавца';
  }

  switch (modelType) {
    case 'userBased':
      return 'Рекомендации по истории поиска';

    case 'itemBased':
      return 'Похожие объявления';

    case 'historyBased':
      return 'Недавно вы смотрели';
  }
}

export function mapStateToProps(state: IState, props: IOwnProps): TStoreProps {
  const { modelType } = props;
  const withoutCompetitors = state.similarOffers[modelType].withoutCompetitors || false;
  const modelVersion = state.similarOffers[modelType].modelVersion;
  const user = getUserEBC(state.offerData.user, state.abGroup);
  const page = getPageEBC(state.offerData.offer.id, state.offerData.breadcrumbs);

  return {
    title: getTitle(modelType, withoutCompetitors),
    agent: state.offerData.agent,
    offer: state.offerData.offer,
    similarOffers: state.similarOffers[modelType].list.slice(0, SIMILAR_OFFERS_MAX_COUNT),
    withoutCompetitors,
    modelVersion,
    modelType,
    user,
    page,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>, props: IOwnProps): TDispatchProps {
  return {
    requestSimilarOffers: (offerId: number, publishedUserId: number) =>
      dispatch(requestSimilarOffers({ offerId, modelType: props.modelType, publishedUserId })),
  };
}

export const SimilarOffersContainer = connect<TStoreProps, TDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(SimilarOffers);
